const getAppRoutes = ({frontCategory}) => [
    {name: 'deeplinks', path: '/:lang(fr)?/cmd/:cmd', page: () => ({page: '/cmd'})},
    {name: 'comment', path: '/:lang(fr)?/comment/:id(\\d{12})/:sortColumn?', page: () => ({page: '/comment'})},
    {name: 'authDebug', path: '/:lang(fr)?/auth-debug', page: () => ({page: '/authDebug'})},
    {name: 'content', path: '/:lang(fr)?/(*(-|/))?:id(\\d{12})$', page: () => ({page: '/content'})},
    {
        name: 'legacy',
        path: '/:legacyLang(ro)?/(*(-|/))?:id(\\d{8})$',
        page: ({query}) => ({page: '/legacy', query})
    },
    {name: 'cockpit', path: '/:lang(fr)?/cockpit', page: () => ({page: '/cockpit'})},
    {name: 'placement', path: '/:lang(fr)?/placement', page: () => ({page: '/placement'})},
    {name: 'profile', path: '/:lang(fr)?/profile', page: () => ({page: '/profile'})},
    {
        name: 'fallback',
        path: '/:lang(fr)?/:pathname(*[^/])?',
        page: ({sitemap, query}) => {
            const {pathname = frontCategory} = query;
            const item = sitemap[pathname];

            if (!item) {
                return {page: '/404', query};
            }

            return item({query});
        }
    }
];

module.exports = {getAppRoutes};
